module.exports = __webpack_public_path__ + "img/3.81b4311a.jpg";